import { Button, Container, Typography } from '@evocolabs/orkaui'
import theme from '@evocolabs/orkaui/lib/theme.cjs'
import { NextSeo } from 'next-seo'
import { useState, useRef } from 'react'
import Link from 'next/link'
import { useInView } from 'react-intersection-observer'
import styles from '@/src/components/scss/AboutUs.module.scss'
import Header from '@/src/components/HeaderV2'
import Footer from '@/src/components/Footer/Footer2'
import ImageCard from '@/src/components/ImageCard'
import { Stack } from '@mui/material'
import FounderStoryModal from '@/src/components/HomePage/Mission/FounderStory'
import joinCDN from '@/src/utils/CDN'
import { Box, useMediaQuery } from '@mui/material'

const picPrefix = 'https://legacy-cdn.hiorka.com/imgs/blog/shareImgs/'

/* START | News Definition */
const orkaNews = [
  {
    pic: picPrefix + 'blog_1006.png',
    category: 'NEWS',
    timeForReading: 5,
    title:
      'A Big Leap Towards a Better Hearing Solution: Orka Launches Orka Two, the Next-Generation Hearing Aid',
    text: 'We understand firsthand the frustrations associated with hearing loss, and we believe that technology can play...',
    date: 'August 14, 2023',
    link: '/blogPage/orka-two'
  },
  {
    pic: picPrefix + 'blog_1005.png',
    category: 'ORKA TECHNOLOGY',
    timeForReading: 7,
    title: 'Why General Chips are the Next Big Leap in Hearing Technology',
    text: 'The accelerating pace of general chip innovation could have a major impact on hearing aids compared to specialty chips..    ',
    date: 'May 29, 2023',
    link: '/blogPage/why-general-chips'
  },
  {
    pic: picPrefix + 'blog_1004.png',
    category: 'USER VOICE',
    timeForReading: 3,
    title: 'Monica’s Story: A New Chapter with Orka Hearing Aids',
    text: 'For most of my life, I found myself constantly asking people to repeat themselves and cranking up the TV volume to deafening levels...',
    date: 'May 29, 2023',
    link: '/blogPage/user-voice-monica'
  }
]
/*  END  | News Definition */

const HeroSection = () => {
  return (
    <div className={styles.hero}>
      <div className={styles.section}>
        <Typography variant="h1" color="#FFFFFF" textAlign="center">
          {'Sound energizes us.'} <br /> {'It makes us feel alive.'}
        </Typography>
      </div>
    </div>
  )
}

const FounderStory = () => {
  const text = {
    title: 'Founder’s Story',
    content: 'Invitation to join us at ground zero and change the industry.',
    ctaText: 'See Founder’s Story'
  }
  const [modalOpen, setModalOpen] = useState(false)
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <Box className={styles.founderStory}>
      <Container>
        <ImageCard
          horizontal={!isMobile}
          src={joinCDN('/imgs/ca-frontend/CEO.jpg', 'CA')}
          flexDirection={{ xs: 'column-reverse', sm: 'row-reverse' }}
          gap={{ xs: 3, sm: 5 }}
          spacing={0}
          title="founderStory"
        >
          <Stack flex={1}>
            <Typography variant="h2">{text.title}</Typography>
            <Typography variant="body2" mb={{ xs: 3, sm: 5 }} mt={2}>
              {text.content}
            </Typography>
            <Button
              variant="secondary"
              sx={{ backgroundColor: 'transparent' }}
              onClick={() => setModalOpen(true)}
              id="about-us-page-founder-story"
            >
              {text.ctaText}
            </Button>
          </Stack>
        </ImageCard>
      </Container>
      <FounderStoryModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </Box>
  )
}

const TotalPkg = () => {
  const [viewMore, setViewMore] = useState(false)
  const hiddenText = useRef(null)
  return (
    <div
      className={styles.splitViewWrapper}
      style={{ backgroundColor: theme.palette.white.warm }}
    >
      <div className={styles.splitView + ' ' + styles.section}>
        <div className={styles.expText}>
          <Typography variant="h2" color={theme.palette.primary[700]}>
            The Total Package
          </Typography>
          <div>
            <Typography variant="body1" color={theme.palette.primary[700]}>
              Innovative Hearing Aid + Expert Assistance = Confident Hearing
              Journey
            </Typography>
            <div
              className={
                styles.expTextDetails +
                ' ' +
                (viewMore
                  ? styles.expTextDetailsShow
                  : styles.expTextDetailsHide)
              }
              style={{
                height: viewMore
                  ? hiddenText.current.offsetHeight + 'px'
                  : '0px'
              }}
            >
              <div ref={hiddenText}>
                <Typography variant="body1" color={theme.palette.primary[700]}>
                  Transitioning to hearing aids can be tough. At Orka, we
                  combine high-quality hearing aids with expert help for an
                  easy, custom experience. Experience a well-supported hearing
                  journey catered to your needs.
                </Typography>
              </div>
            </div>
          </div>
          <Typography
            variant="Link"
            color={theme.palette.primary[500]}
            onClick={() => {
              setViewMore(!viewMore)
            }}
          >
            {viewMore ? 'View Less' : 'View More'}
          </Typography>
        </div>
        <div className={styles.totalPkgPic}>
          <div className={styles.totalPkgPicItem + ' ' + styles.totalPkgImg1} />
          <div className={styles.totalPkgPicItem + ' ' + styles.totalPkgImg2} />
          <div className={styles.totalPkgPicItem + ' ' + styles.totalPkgImg3} />
          <div className={styles.totalPkgPicItem + ' ' + styles.totalPkgImg4} />
          <div className={styles.totalPkgPicItem + ' ' + styles.totalPkgImg5} />
          <div className={styles.totalPkgPicItem + ' ' + styles.totalPkgImg6} />
        </div>
      </div>
    </div>
  )
}

const OneOfAKind = () => {
  const [viewMore, setViewMore] = useState(false)
  const hiddenText = useRef(null)
  return (
    <div
      className={styles.splitViewWrapper}
      style={{ backgroundColor: theme.palette.secondary[100] }}
    >
      <div
        className={
          styles.splitView + ' ' + styles.section + ' ' + styles.oneOfAKind
        }
      >
        <div className={styles.oneOfAKindPic} />
        <div className={styles.expText}>
          <Typography
            variant="h2"
            color={theme.palette.primary[700]}
            textAlign="auto"
          >
            You are One-of-a-Kind
          </Typography>
          <div>
            <Typography
              variant="body1"
              color={theme.palette.primary[700]}
              textAlign="auto"
            >
              We care about your story, lifestyle, and preference - not just
              your audiogram.
            </Typography>
            <div
              className={
                styles.expTextDetails +
                ' ' +
                (viewMore
                  ? styles.expTextDetailsShow
                  : styles.expTextDetailsHide)
              }
              style={{
                height: viewMore
                  ? hiddenText.current.offsetHeight + 'px'
                  : '0px'
              }}
            >
              <div ref={hiddenText}>
                <Typography
                  variant="body1"
                  color={theme.palette.primary[700]}
                  textAlign="auto"
                >
                  We adjust hearing aids to fit your life effortlessly. Feel
                  free to involve family or friends in sessions — their input is
                  valuable. We're your friendly partner committed to making your
                  hearing journey enjoyable and customized, with input from
                  those who know you best.
                </Typography>
              </div>
            </div>
          </div>
          <Typography
            variant="Link"
            color={theme.palette.primary[500]}
            onClick={() => {
              setViewMore(!viewMore)
            }}
            textAlign="auto"
          >
            {viewMore ? 'View Less' : 'View More'}
          </Typography>
        </div>
      </div>
    </div>
  )
}

const PaceComfort = () => {
  const { ref, inView } = useInView({ threshold: 0.8 })
  return (
    <div style={{ backgroundColor: theme.palette.white.warm }}>
      <div className={styles.section + ' ' + styles.paceComfort}>
        <div className={styles.paceComfortText}>
          <Typography variant="h2" color={theme.palette.primary[700]}>
            Your Pace, Your Comfort
          </Typography>
          <Typography variant="body1" color={theme.palette.primary[700]}>
            Our solutions adapt to match your pace and comfort — no best
            practices or industry guidelines should stand in your way.
          </Typography>
        </div>
        <div className={styles.paceImgWrapper} ref={ref}>
          <div
            className={
              styles.paceImgText +
              ' ' +
              (inView ? styles.paceImgTextShow : styles.paceImgTextHidden)
            }
          >
            <Typography
              variant="h4"
              color="#FFFFFF"
              className={
                styles.paceText +
                ' ' +
                (inView ? styles.paceTextShow : styles.paceTextHidden)
              }
            >
              How many sessions will it take to optimize your hearing aids?
            </Typography>
            <Typography
              variant="body2"
              color="#FFFFFF"
              className={
                styles.paceText +
                ' ' +
                (inView ? styles.paceTextShow : styles.paceTextHidden)
              }
            >
              The number of sessions varies for each person, but rest assured,
              our Orka hearing care professionals are committed to working with
              you until you're completely satisfied. Plus, forget about the
              hassle of traveling; we offer remote sessions for your
              convenience, catering to your needs and comfort right from your
              own home!
            </Typography>
          </div>
        </div>
      </div>
    </div>
  )
}

const Forbes = () => {
  return (
    <div style={{ backgroundColor: theme.palette.secondary[100] }}>
      <div className={styles.section + ' ' + styles.forbes}>
        <div className={styles.forbesTextWrapper}>
          <div className={styles.forbesText}>
            <Typography variant="h3" color={theme.palette.primary[700]}>
              “Orka is using AI and machine learning in innovative ways not
              merely for tech’s sake.”
            </Typography>
            <Typography variant="body2" color={theme.palette.primary[700]}>
              “They want to make their dent in the universe by making hearing
              aids accessible and approachable to everyone.”
            </Typography>
          </div>
          <div className={styles.forbesLogo}>
            <img src={picPrefix + 'aboutus-forbesLogo.png'} alt="Forbes" />
          </div>
        </div>
        <div className={styles.forbesImg} />
      </div>
    </div>
  )
}

const GetToKnow = () => {
  return (
    <div>
      <div className={styles.section + ' ' + styles.getToKnow}>
        <Typography
          variant="h2"
          color={theme.palette.primary[700]}
          textAlign="center"
        >
          Get to Know Orka Now
        </Typography>
        <div className={styles.getToKnowItems}>
          {orkaNews.map((data, idx) => {
            return (
              <Link key={idx} className={styles.getToKnowItem} href={data.link}>
                <div
                  className={styles.orkaNewsPic}
                  style={{ backgroundImage: `url(${data.pic})` }}
                />
                <div className={styles.orkaNewsTags}>
                  <Typography variant="button" color={theme.palette.grey[300]}>
                    {data.category}
                  </Typography>
                  <Typography variant="t2" color={theme.palette.grey[300]}>
                    - {data.timeForReading} min read
                  </Typography>
                </div>
                <div className={styles.orkaNewsText}>
                  <Typography variant="h4" color={theme.palette.primary[700]}>
                    {data.title}
                  </Typography>
                  <Typography variant="body3" color={theme.palette.grey[600]}>
                    {data.text}
                  </Typography>
                </div>
                <div className={styles.orkaNewsDate}>
                  <Typography variant="body5" color={theme.palette.grey[600]}>
                    {data.date}
                  </Typography>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

const AboutUs = () => {
  return (
    <>
      <NextSeo
        title="About Us | Orka - Hear What Matters"
        description="Orka is committed to doing their part in shepherding the healthcare industry towards a more modern form that embraces cutting-edge tech."
      />
      <div>
        <Header isWhiteBg />
        <div>
          <HeroSection />
          <FounderStory />
          <TotalPkg />
          <OneOfAKind />
          <PaceComfort />
          <Forbes />
          <GetToKnow />
        </div>
        <Footer />
      </div>
    </>
  )
}

export default AboutUs
